var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as SavvyResultsUI from "./SavvyResultsUI/SavvyResultsUI";
import { InsuranceProducts } from "../constants";
import { convertCentsToDollars, shouldOpenInSameWindow } from "../lib/util";
import { clickedBuyQuoteButton } from "../lib/Avo";
import handleResultClick from "../utils/handleResultClick";
import { rc2Issuers } from "../lib/constants";
import useAffiliateConfig from "../hooks/useAffiliateConfig";
import useAppSelector from "../hooks/useAppSelector";
import useEventPublisher from "../hooks/useEventPublisher";
export function getQuotePriceSecondaryText(_a) {
    var isRc2 = _a.isRc2, isAd = _a.isAd;
    if (isAd) {
        return;
    }
    return isRc2 ? "Final Rate" : "Estimate";
}
export default function Quote(_a) {
    var quote = _a.quote, impressionId = _a.impressionId, index = _a.index, bottomContent = _a.bottomContent, insuranceType = _a.insuranceType;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var insuranceProduct = useAppSelector(function (state) { return state.applicant; }).insuranceProduct;
    var eventPublisher = useEventPublisher();
    var topOfferBadge = useAffiliateConfig().topOfferBadge;
    var isRc2 = quote.issuerId ? rc2Issuers.includes(quote.issuerId) : false;
    function handleClick(ev) {
        ev.preventDefault();
        var openInSameWindow = shouldOpenInSameWindow();
        clickedBuyQuoteButton(__assign(__assign({}, commonAnalyticsProperties), { impressionType: "Standard", 
            // the result list index is 1 based, and we pass 0-based indexes from arrays
            resultListPosition: index ? index + 1 : undefined, openInNewWindow: !openInSameWindow }));
        eventPublisher.clickOffer(quote, impressionId);
        if (quote.clickUrl) {
            handleResultClick(quote.clickUrl, openInSameWindow);
        }
    }
    var anchorProps = {
        onClick: handleClick,
        href: quote.clickUrl,
        "data-testid": quote.issuerId,
        title: quote.clickText,
    };
    return (React.createElement(SavvyResultsUI.Card, { anchorProps: anchorProps, name: quote.issuerName || "", issuerId: quote.issuerId, badge: index === 0 && topOfferBadge ? (React.createElement(SavvyResultsUI.Badge, { variant: "green" }, "Top Option")) : undefined, clickText: quote.quoteMonthlyCentsCost ? (React.createElement(SavvyResultsUI.PricePerUnitInDollars, { priceInDollars: convertCentsToDollars(insuranceProduct === InsuranceProducts.Home
                ? quote.totalPremiumCents
                : quote.quoteMonthlyCentsCost), unit: insuranceProduct === InsuranceProducts.Home ? "year" : "month", secondaryText: getQuotePriceSecondaryText({
                isRc2: isRc2,
                isAd: false,
            }) })) : null, bottomContent: bottomContent, variant: index === 0 ? "highlight" : "default", insuranceType: insuranceType }));
}
